import React from 'react';
import { View } from 'react-native';
const S = {
    dividerHorizontal: { height: 1 },
    dividerVertical: { width: 1, flex: 1 },
};
const variantColors = {
    'default': { backgroundColor: '#E8E6E9' },
    'virtual': { backgroundColor: '#383838' },
    'versioning': { backgroundColor: '#F1F1F1' },
};
export const DNADivider = (props) => {
    const { vertical, height, width, style, fill, variant = 'default' } = props;
    return (<View style={[
        vertical ? S.dividerVertical : S.dividerHorizontal,
        variantColors[variant],
        height ? { minHeight: height } : {},
        width ? { minWidth: width } : {},
        fill ? { flex: 1 } : {},
        style,
    ]}/>);
};
export default DNADivider;
//# sourceMappingURL=DNADivider.js.map